import DeleteIcon from '../components/DeleteIcon';
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './VerificacaoAndaime.css';
import './RelatoriosThemes.css';
import { MaquetesThemeProvider, useMaquetesTheme } from '../context/MaquetesThemeContext';
import { OrcamentoFeedbackProvider, useOrcamentoFeedback } from '../components/OrcamentoUI';
import ReportThemeIcon from '../components/ReportThemeIcon';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

// Itens de verificação de acordo com o anexo
const CHECKLIST_ITEMS = [
    { id: '1.1', text: 'A montagem e a desmontagem dos andaimes são feitas por profissionais competentes, devidamente enquadrados?', section: '1-Utilização de Andaimes' },
    { id: '1.2', text: 'Estão criadas bases firmes e estáveis para os apoios dos andaimes, tendo em vista garantir a sua estabilidade?', section: '1-Utilização de Andaimes' },
    { id: '1.3', text: 'A montagem foi realizada de acordo com o plano de montagem e contemplando as instruções do fabricante?', section: '1-Utilização de Andaimes' },
    { id: '1.4', text: 'A estrutura foi nivelada na fase inicial, após a colocação das primeiras plataformas e só depois foi continuada a montagem?', section: '1-Utilização de Andaimes' },
    { id: '1.5', text: 'Todas as peças/elementos são originais e pertencem ao andaime verificado?', section: '1-Utilização de Andaimes' },
    { id: '1.6', text: 'Todas as peças do andaime são corretamente movimentadas durante a sua montagem, sem sofrerem embates ou quedas?', section: '1-Utilização de Andaimes' },
    { id: '1.7', text: 'Todos os elementos do andaime estão devidamente fixados entre si, não pondo em causa a estabilidade do equipamento?', section: '1-Utilização de Andaimes' },
    { id: '1.8', text: 'Os andaimes estão limpos e não são utilizados como locais de armazenagem de materiais?', section: '1-Utilização de Andaimes' },
    { id: '1.9', text: 'Os trabalhadores possuem formação adequada?', section: '1-Utilização de Andaimes' },
    { id: '1.10', text: 'Os andaimes encontram-se protegidos contra choques provenientes da circulação de veículos e a movimentação aérea de cargas não interfere com o seu posicionamento?', section: '1-Utilização de Andaimes' },
    { id: '1.11', text: 'O andaime possui acessos?', section: '1-Utilização de Andaimes' },
    { id: '1.12', text: 'O acesso ao andaime é feito pelo interior?', section: '1-Utilização de Andaimes' },
    { id: '1.13', text: 'Sendo andaime móvel possui sistema de travamento e este funciona corretamente?', section: '1-Utilização de Andaimes' },
    { id: '1.14', text: 'As diagonais foram corretamente montadas?', section: '1-Utilização de Andaimes' },
    { id: '1.15', text: 'Todos os elementos de segurança foram montados (guarda-corpos, guarda-cabeças)?', section: '1-Utilização de Andaimes' },
    { id: '1.16', text: 'A largura mínima da plataforma de trabalho é de:\\n• 60 cm em zonas de trabalhos de reparação\\n• 80 cm em zonas de trabalhos de construção', section: '1-Utilização de Andaimes' },
    { id: '1.17', text: 'Verificam-se as seguintes condições de distância do andaime à parede?\\n• Se 25 cm < d > 50 cm, existe uma barra de proteção a 1 metro de altura\\n• Se d > 50 cm, existe uma dupla proteção interior', section: '1-Utilização de Andaimes' },
    { id: '1.18', text: 'As plataformas de trabalho encontram-se livres de obstáculos e detritos e apresentam piso antiderrapante?', section: '1-Utilização de Andaimes' },
    { id: '1.19', text: 'Todas as plataformas de trabalho e aberturas nos pavimentos ou em paredes a menos de 1m acima do pavimento, têm proteções montadas em permanência?', section: '1-Utilização de Andaimes' },
    { id: '1.20', text: 'Durante a montagem e a desmontagem dos andaimes, os trabalhadores envolvidos utilizam os equipamentos de proteção indispensáveis (Luvas, calçado, capacete, arnês)?', section: '1-Utilização de Andaimes' },
    { id: '2.1', text: 'É efetuada manutenção periódica do equipamento?', section: '2-Manutenção do Equipamento' },
    { id: '2.2', text: 'Todos os elementos do andaime se encontram em bom estado de conservação?', section: '2-Manutenção do Equipamento' },
    { id: '2.3', text: 'Todas as peças estão limpas e livres de substâncias nocivas que as possam danificar?', section: '2-Manutenção do Equipamento' },
    { id: '3.1', text: 'O equipamento está concebido de modo que os trabalhadores sejam protegidos contra os riscos de:\\n a) Contacto directo ou indirecto com a eletricidade?', section: '3-Riscos Elétricos' },
    { id: '4.1', text: 'O equipamento está devidamente sinalizado com avisos para garantir a segurança dos trabalhadores?', section: '4-Sinalização de Segurança' },
    { id: '4.2', text: 'O equipamento de trabalho ostenta sinalização com a sua carga nominal?', section: '4-Sinalização de Segurança' },
    { id: '4.3', text: 'Estando o andaime em zona de circulação de máquinas e/ou veículos, o equipamento está devidamente sinalizado?', section: '4-Sinalização de Segurança' },
];

const MAX_PHOTOS = 4;

const VerificacaoAndaimeContent = () => {
    const { theme } = useMaquetesTheme();
    const { notify, confirm } = useOrcamentoFeedback();
    const liquid = theme === 'liquido';
    const icon = (name, fallback) => liquid ? <ReportThemeIcon name={name} /> : fallback;
    const { user } = useAuth(); // Assume we have the logged-in user
    const navigate = useNavigate();

    const [obras, setObras] = useState([]);
    const [equipamentos, setEquipamentos] = useState([]);
    const [users, setUsers] = useState([]);

    const [formData, setFormData] = useState({
        obra_id: '',
        equipamento_id: '',
        data_verificacao: new Date().toISOString().split('T')[0],
        resultado_usavel: true,
        observacoes_finais: '',
    });

    const [checklistData, setChecklistData] = useState({});
    const [fotos, setFotos] = useState([]); // will store base64 strings

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [pdfLink, setPdfLink] = useState(null);
    const [generatedId, setGeneratedId] = useState(null);
    const [extraEmails, setExtraEmails] = useState([]);
    const [extraEmailInput, setExtraEmailInput] = useState('');

    // Initialize checklist with all 'C' (Conforme)
    useEffect(() => {
        const initialChecklist = {};
        CHECKLIST_ITEMS.forEach(item => {
            initialChecklist[`item_${item.id}`] = { status: 'C', obs: '' };
        });
        setChecklistData(initialChecklist);
    }, []);

    // Fetch Obras & Equipamentos
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                // Adjust endpoints to your actual project APIs if they differ
                const [obrasRes, equipRes, usersRes] = await Promise.all([
                    api.get('/obras'),
                    api.get('/equipamentos'),
                    api.get('/auth/users').catch(() => ({ data: [] }))
                ]);

                // Keep active/in progress obras if there's a status field, or all
                const obrasList = obrasRes.data.obras || obrasRes.data;
                const activeObras = obrasList.filter(o => o.estado !== 'Concluida' && o.estado !== 'Cancelada');
                setObras(activeObras.length > 0 ? activeObras : obrasList);

                // Ideally filter by equipment type = 'Andaime' if available
                const equipList = equipRes.data.equipamentos || equipRes.data;
                const andaimes = equipList.filter(e =>
                    e.nome?.toLowerCase().includes('andaime') ||
                    e.tipo?.toLowerCase().includes('andaime') ||
                    e.categoria?.toLowerCase().includes('andaime')
                );

                setEquipamentos(andaimes.length > 0 ? andaimes : equipList);
                setUsers(usersRes.data || []);
            } catch (err) {
                console.error("Erro a carregar dados iniciais:", err);
                setMessage({ type: 'error', text: 'Não foi possível carregar as obras e equipamentos.' });
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleChecklistChange = (itemId, field, value) => {
        setChecklistData(prev => ({
            ...prev,
            [`item_${itemId}`]: {
                ...prev[`item_${itemId}`],
                [field]: value
            }
        }));
    };

    // Photo Capture/Upload Handling
    const handlePhotoUpload = (e) => {
        const files = Array.from(e.target.files);

        if (fotos.length + files.length > MAX_PHOTOS) {
            notify(`Pode adicionar no máximo ${MAX_PHOTOS} fotos.`);
            return;
        }

        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // Basic compression/resize could happen here before saving state
                // For now, storing raw base64 from FileReader
                setFotos(prev => [...prev, reader.result]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removePhoto = (indexToRemove) => {
        setFotos(prev => prev.filter((_, idx) => idx !== indexToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.obra_id || !formData.equipamento_id) {
            setMessage({ type: 'error', text: 'Por favor, selecione a Obra e o Equipamento.' });
            return;
        }

        setIsSubmitting(true);
        setMessage({ type: '', text: '' });
        setPdfLink(null);
        setGeneratedId(null);

        try {
            const payload = {
                ...formData,
                checklist: checklistData,
                fotos_base64: fotos,
                tecnico_id: user?.id, // Assumes user ctx has ID mapping to trabalhador
                // o servidor usa o nome e o cargo da ficha do trabalhador, quando a há
                nome_tecnico: user?.nome_completo || user?.username || '',
                cargo_tecnico: '',
                // assinatura_snapshot: base64 of canvas if we had a signature pad here
            };

            const response = await api.post('/andaimes', payload);

            setMessage({ type: 'success', text: 'Verificação submetida com sucesso!' });
            const newId = response.data.id;
            setGeneratedId(newId);
            setPdfLink(`/andaimes/relatorio/${newId}?t=${response.data.share_token}`);

        } catch (err) {
            console.error(err);
            setMessage({ type: 'error', text: 'Erro ao submeter a verificação. Tente novamente.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleShare = async () => {
        if (!pdfLink) return;

        try {
            if (navigator.share) {
                await navigator.share({
                    title: 'Relatório de Verificação de Andaime',
                    text: 'Consulte o relatório de verificação neste link:',
                    url: window.location.origin + '/api' + pdfLink
                });
            } else {
                window.open(pdfLink, '_blank');
            }
        } catch (err) {
            console.error('Erro na partilha:', err);
            notify('Não foi possível partilhar ou transferir o ficheiro neste dispositivo.');
        }
    };

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const addExtraEmail = () => {
        const parts = extraEmailInput.split(/[,;\s]+/).map(p => p.trim()).filter(Boolean);
        if (!parts.length) return;

        const invalid = parts.filter(p => !isValidEmail(p));
        if (invalid.length) {
            notify('Email inválido: ' + invalid.join(', '));
            return;
        }

        setExtraEmails(prev => [...new Set([...prev, ...parts.map(p => p.toLowerCase())])]);
        setExtraEmailInput('');
    };

    const removeExtraEmail = (emailToRemove) => {
        setExtraEmails(prev => prev.filter(e => e !== emailToRemove));
    };

    const handleSendToSeguranca = async () => {
        if (!generatedId) return;

        const selecObra = obras.find(o => o.id === parseInt(formData.obra_id));
        if (!selecObra) {
            notify('Obra não encontrada. Não é possível identificar o contacto.');
            return;
        }

        const segurancaUser = users.find(u => u.id === selecObra.seguranca_obra_id);
        // Prioridade: 1) email do utilizador selecionado como segurança, 2) campo email_seguranca da obra
        const emailAlvo = (segurancaUser?.email) || selecObra.email_seguranca || null;
        const nomeSeguranca = segurancaUser?.nome || 'Segurança de Obra';

        if (!emailAlvo && extraEmails.length === 0) {
            notify('Nenhum Técnico de Segurança associado a esta obra ou falta de email configurado. Pode adicionar um email pontual abaixo.');
            return;
        }

        const listaDestinos = [
            emailAlvo ? `${nomeSeguranca} - ${emailAlvo}` : null,
            ...extraEmails
        ].filter(Boolean).join('\n• ');

        if (!(await confirm(`Enviar PDF por email para:\n• ${listaDestinos}?`))) return;

        try {
            setMessage({ type: '', text: 'A enviar e-mail...' });
            await api.post(`/andaimes/relatorio/${generatedId}/email`, { targetEmail: emailAlvo, extraEmails });
            notify('E-mail enviado com sucesso para a Segurança de Obra!');
            setMessage({ type: 'success', text: 'E-mail enviado com sucesso!' });
        } catch (error) {
            console.error('Erro ao enviar e-mail:', error);
            notify('Erro a enviar o e-mail: ' + (error.response?.data?.error || error.message));
            setMessage({ type: 'error', text: 'Erro ao enviar o e-mail.' });
        }
    };

    const handleDownloadPdf = async () => {
        if (!pdfLink) return;
        try {
            setMessage({ type: '', text: 'A carregar PDF...' });
            const response = await api.get(pdfLink, { responseType: 'blob' });
            const blob = response.data;
            const downloadUrl = window.URL.createObjectURL(blob);
            window.open(downloadUrl, '_blank');
            setMessage({ type: '', text: '' });
        } catch (err) {
            console.error('Erro ao abrir PDF:', err);
            notify('Não foi possível abrir o PDF. ' + (err.response?.data?.error || err.message));
            setMessage({ type: 'error', text: 'Erro ao abrir PDF.' });
        }
    };

    const sections = [...new Set(CHECKLIST_ITEMS.map(item => item.section))];

    return (
        <div className="verificacao-andaimes-container" data-report-theme={liquid ? 'liquido' : undefined}>
            <div className="top-bar">
                <div className="top-bar-left">
                    <div className="top-bar-title">
                        <h1>{icon('andaime', '🪜')} Verificação de Andaimes</h1>
                        <p className="mobile-hide">Equipamentos Subitil</p>
                    </div>
                </div>
                <div className="top-bar-actions">
                    {!user?.perfil_mobile && (
                        <button className="btn-secondary" onClick={() => navigate(-1)}>
                            {icon('back', '←')} Voltar
                        </button>
                    )}
                    {user?.perfil_mobile && (
                        <button className="btn-secondary" onClick={() => navigate('/mobile-dashboard')}>
                            {icon('back', '←')} Menu
                        </button>
                    )}
                </div>
            </div>

            <div className="page-content" style={{ padding: '20px' }}>
                <div className="va-content-wrapper">
                    {message.text && (
                        <div className={`va-message ${message.type}`}>
                            {message.text}
                        </div>
                    )}

                    {!pdfLink ? (
                        <form className="va-form" onSubmit={handleSubmit}>
                            <div className="va-identification">
                            <div className="va-form-group">
                                <label htmlFor="va-obra_id">Obra*</label>
                                <select
                                    id="va-obra_id" name="obra_id"
                                    value={formData.obra_id}
                                    onChange={handleFormChange}
                                    required
                                    disabled={isLoading}
                                >
                                    <option value="">Selecione uma Obra</option>
                                    {obras.map(o => (
                                        <option key={o.id} value={o.id}>{o.posicao}{o.descricao ? ` — ${o.descricao}` : ''}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="va-form-group">
                                <label htmlFor="va-equipamento_id">Equipamento (Andaime)*</label>
                                <select
                                    id="va-equipamento_id" name="equipamento_id"
                                    value={formData.equipamento_id}
                                    onChange={handleFormChange}
                                    required
                                    disabled={isLoading}
                                >
                                    <option value="">Selecione o Equipamento</option>
                                    {equipamentos.map(e => (
                                        <option key={e.id} value={e.id}>{e.nome} {e.n_serie ? `(S/N: ${e.n_serie})` : ''}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="va-form-group">
                                <label htmlFor="va-data_verificacao">Data da Verificação</label>
                                <input
                                    type="date"
                                    id="va-data_verificacao" name="data_verificacao"
                                    value={formData.data_verificacao}
                                    onChange={handleFormChange}
                                    required
                                />
                            </div>

                            </div>
                            <div className="va-checklist-section">
                                <h3>Checklist de Verificação</h3>

                                {sections.map(sectionName => (
                                    <div key={sectionName} className="va-section-block">
                                        <h4 className="va-section-title">{sectionName}</h4>
                                        <div className="va-table-wrapper">
                                            <table className="va-table">
                                                <thead>
                                                    <tr>
                                                        <th className="th-req">Requisito</th>
                                                        <th className="th-opt">C</th>
                                                        <th className="th-opt">NC</th>
                                                        <th className="th-opt">NA</th>
                                                        <th className="th-obs">Obs</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {CHECKLIST_ITEMS.filter(it => it.section === sectionName).map(item => (
                                                        <tr key={item.id}>
                                                            <td className="td-req">
                                                                <span className="req-id">{item.id}</span>
                                                                <span className="req-text">{item.text.split('\\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}</span>
                                                            </td>
                                                            <td className="td-opt">
                                                                <input
                                                                    type="radio"
                                                                    name={`status_${item.id}`}
                                                                    aria-label={`${item.id}: Conforme`}
                                                                    checked={checklistData[`item_${item.id}`]?.status === 'C'}
                                                                    onChange={() => handleChecklistChange(item.id, 'status', 'C')}
                                                                />
                                                            </td>
                                                            <td className="td-opt">
                                                                <input
                                                                    type="radio"
                                                                    name={`status_${item.id}`}
                                                                    aria-label={`${item.id}: Não conforme`}
                                                                    checked={checklistData[`item_${item.id}`]?.status === 'NC'}
                                                                    onChange={() => handleChecklistChange(item.id, 'status', 'NC')}
                                                                />
                                                            </td>
                                                            <td className="td-opt">
                                                                <input
                                                                    type="radio"
                                                                    name={`status_${item.id}`}
                                                                    aria-label={`${item.id}: Não aplicável`}
                                                                    checked={checklistData[`item_${item.id}`]?.status === 'NA'}
                                                                    onChange={() => handleChecklistChange(item.id, 'status', 'NA')}
                                                                />
                                                            </td>
                                                            <td className="td-obs">
                                                                <input
                                                                    type="text"
                                                                    aria-label={`Observações do requisito ${item.id}`}
                                                                    placeholder="..."
                                                                    value={checklistData[`item_${item.id}`]?.obs || ''}
                                                                    onChange={(e) => handleChecklistChange(item.id, 'obs', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="va-form-group va-result-group">
                                <label>Resultado Final</label>
                                <div className="va-radio-row">
                                    <label>
                                        <input
                                            type="radio"
                                            name="resultado_usavel"
                                            checked={formData.resultado_usavel === true}
                                            onChange={() => setFormData(prev => ({ ...prev, resultado_usavel: true }))}
                                        />
                                        Apto para Uso
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="resultado_usavel"
                                            checked={formData.resultado_usavel === false}
                                            onChange={() => setFormData(prev => ({ ...prev, resultado_usavel: false }))}
                                        />
                                        Não Apto
                                    </label>
                                </div>
                            </div>

                            <div className="va-form-group">
                                <label htmlFor="va-observacoes_finais">Observações Finais</label>
                                <textarea
                                    id="va-observacoes_finais" name="observacoes_finais"
                                    rows="3"
                                    value={formData.observacoes_finais}
                                    onChange={handleFormChange}
                                    placeholder="Notas adicionais sobre o estado do andaime..."
                                ></textarea>
                            </div>

                            <div className="va-photos-section">
                                <label>Registo Fotográfico (Max {MAX_PHOTOS})</label>
                                <div className="photo-upload-wrapper">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        multiple
                                        onChange={handlePhotoUpload}
                                        disabled={fotos.length >= MAX_PHOTOS}
                                        id="photo-upload"
                                    />
                                    <label htmlFor="photo-upload" className={`upload-btn ${fotos.length >= MAX_PHOTOS ? 'disabled' : ''}`}>
                                        {icon('camera', '📷')} Tirar / Anexar Fotos
                                    </label>
                                </div>

                                {fotos.length > 0 && (
                                    <div className="photo-preview-grid">
                                        {fotos.map((src, index) => (
                                            <div key={index} className="photo-thumbnail">
                                                <img src={src} alt={`Foto ${index + 1}`} />
                                                <button type="button" className="remove-photo-btn" onClick={() => removePhoto(index)} aria-label={`Remover foto ${index + 1}`}><DeleteIcon /></button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="va-actions">
                                <button type="submit" className="va-submit-btn" disabled={isSubmitting}>
                                    {!isSubmitting && icon('save', '')}{isSubmitting ? 'A submeter...' : 'Guardar Verificação'}
                                </button>
                            </div>
                        </form>
                    ) : (
                        <div className="va-success-actions">
                            <p className="success-text">{icon('check', '✔️')} Relatório gerado com sucesso!</p>
                            <div className="btn-group" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <button onClick={handleDownloadPdf} className="va-action-btn download-btn">
                                    {icon('pdf', '🖨️')} Imprimir / Ver PDF
                                </button>
                                <div className="va-extra-emails">
                                    <label htmlFor="va-extra-email" style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>
                                        Emails pontuais (técnicos no terreno)
                                    </label>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <input
                                            type="email" id="va-extra-email"
                                            value={extraEmailInput}
                                            onChange={(e) => setExtraEmailInput(e.target.value)}
                                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addExtraEmail(); } }}
                                            placeholder="email@exemplo.pt"
                                            style={{ flex: 1, padding: '10px', border: '1px solid #cbd5e0', borderRadius: '6px', fontSize: '14px' }}
                                        />
                                        <button type="button" aria-label="Adicionar email" onClick={addExtraEmail} className="va-action-btn" style={{ width: 'auto', padding: '0 16px', backgroundColor: '#4a5568', color: 'white' }}>
                                            {icon('plus', '➕')}
                                        </button>
                                    </div>
                                    {extraEmails.length > 0 && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                                            {extraEmails.map(email => (
                                                <span className="va-email-pill" key={email} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#edf2f7', border: '1px solid #cbd5e0', borderRadius: '14px', padding: '4px 10px', fontSize: '13px' }}>
                                                    {email}
                                                    <button type="button" aria-label={`Remover ${email}`} onClick={() => removeExtraEmail(email)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#e53e3e', fontWeight: 'bold', padding: 0 }}><DeleteIcon /></button>
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <button onClick={handleSendToSeguranca} className="va-action-btn" style={{ backgroundColor: '#e53e3e', color: 'white' }}>
                                    {icon('mail', '📧')} Enviar para Seg. Obra{extraEmails.length > 0 ? ` (+${extraEmails.length})` : ''}
                                </button>
                                <button onClick={handleShare} className="va-action-btn share-btn">
                                    {icon('share', '📤')} Partilhar Link (Outras Apps)
                                </button>
                            </div>
                            <button onClick={() => { setPdfLink(null); setExtraEmails([]); setExtraEmailInput(''); window.scrollTo(0, 0); }} className="va-action-btn secondary-btn" style={{ marginTop: '15px' }}>
                                {icon('plus', '➕')} Nova Verificação
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const VerificacaoAndaime = () => <MaquetesThemeProvider><OrcamentoFeedbackProvider><VerificacaoAndaimeContent /></OrcamentoFeedbackProvider></MaquetesThemeProvider>;
export default VerificacaoAndaime;
